import RemoteSelect from "common/components/RemoteSelect/RemoteSelect";
import usePark from "common/hooks/usePark";
import { Sector } from "types/Sector";

const processOptions = (options: Sector[]) =>
  options.map(({ id, name }) => ({
    value: id,
    label: name,
  }));

function SectorSelect(props: any) {
  const { park } = usePark();

  return (
    <RemoteSelect
      url="sectors"
      processOptions={processOptions}
      filters={[{ name: "park", value: park?.id }]}
      {...props}
    />
  );
}

export default SectorSelect;
